module.exports = __webpack_public_path__ + "static/img/wo_nohead.55e2355.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/wo_nohead.png
// module id = T61U
// module chunks = 1